import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild,
    ViewEncapsulation,
    OnInit,
    OnChanges,
    SimpleChanges,
    ElementRef,
    AfterViewInit,
    ChangeDetectorRef,
    AfterContentInit,
} from '@angular/core';
import { Location } from '@angular/common';
import { IonPopover } from '@ionic/angular';

@Component({
    selector: 'dwin-header',
    templateUrl: './dwin-header.component.html',
    styleUrls: ['./dwin-header.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class DwinHeaderComponent implements OnInit, OnChanges, AfterViewInit, AfterContentInit {
    @Input() title = '';
    @Input() id = '';
    @Input() subtitle = '';
    @Input() subtitle_h1 = '';
    @Input() customBackButton = false;
    @Input() backButton = false;
    @Input() closingX = false;
    @Input() isProjectInfoHeader = false;
    @Input() isProjectDetailHeader = false;
    @Input() isStateInputHeader = false;
    @Input() origin: string = '';
    @Input() noBottomBorder = false;

    @Output() closeClicked = new EventEmitter();
    @Output() ellipsisClicked = new EventEmitter();
    @Output() customBackClicked = new EventEmitter();
    @ViewChild('popover', { static: true }) popover: IonPopover;
    @ViewChild('titleDiv') titleDiv!: ElementRef;
    @ViewChild('titleStateDiv') titleStateDiv!: ElementRef;
    @ViewChild('refBarContainer') refBarContainer!: ElementRef;

    @ViewChild('headerRow') headerRow: ElementRef;
    @ViewChild('titleContainer') titleContainer: ElementRef;
    @ViewChild('titleRef') titleRef: ElementRef;
    @ViewChild('rightCol') rightCol: ElementRef;

    private resizeObserverWidth: ResizeObserver;
    private resizeObserverHeight: ResizeObserver;
    private headerRowHeight: number;

    isCancelProjectPopoverOpen = false;
    isMultiline = false;

    leftGrid = '1.5';
    middleGrid = '8.5';
    rightGrid = '2';

    constructor(
        private location: Location,
        private cdr: ChangeDetectorRef,
    ) {}
    ngOnInit() {
        this.updateMultilineState();
    }

    onBackClicked() {
        if (!this.backButton) return;
        this.location.back();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.title || changes.subtitle || changes.subtitle_h1) {
            this.updateMultilineState();
        }
    }

    ngAfterViewInit() {
        this.resizeObserverWidth = new ResizeObserver(() => {
            this.setTitleWidthDynamically();
        });
        this.resizeObserverHeight = new ResizeObserver(() => {
            this.setTitleHeightDynamically();
        });
        if (this.rightCol) {
            this.resizeObserverWidth.observe(this.rightCol.nativeElement);
        }
        if (this.titleRef) {
            this.resizeObserverHeight.observe(this.titleRef.nativeElement);
        }
        this.setDynamicGridSizes();
        /*requestAnimationFrame(() => {
            this.setDynamicGridSizes();
            this.updateMultilineState();
        });*/
    }

    ngAfterContentInit() {
        this.checkIfTitleIsMultiline();
    }

    onCloseClicked() {
        if (!this.closingX) return;
        this.closeClicked.emit();
    }

    onEllipsisClicked() {
        this.isCancelProjectPopoverOpen = false;
        this.ellipsisClicked.emit();
    }

    onCustomBackClicked() {
        if (this.customBackButton) {
            this.customBackClicked.emit();
        }
    }

    presentPopover(e: Event) {
        this.popover.event = e;
        this.isCancelProjectPopoverOpen = true;
    }

    private updateMultilineState() {
        this.cdr.detectChanges();
        this.checkIfTitleIsMultiline();
        this.cdr.detectChanges();
    }

    private checkIfTitleIsMultiline() {
        this.updateMultiline(this.titleStateDiv);
        this.updateMultiline(this.titleDiv);
        this.cdr.detectChanges();
    }

    private updateMultiline(elementRef: ElementRef) {
        if (elementRef && elementRef.nativeElement) {
            this.cdr.detectChanges();
            const element = elementRef.nativeElement;
            const divHeight = element.offsetHeight;
            const lineHeight = parseInt(window.getComputedStyle(element).lineHeight, 10);
            this.isMultiline = divHeight * 0.9 > lineHeight;
        }
    }

    private setDynamicGridSizes() {
        if (this.isMultiline) {
            this.leftGrid = '1.3';
            this.middleGrid = '8.7';
            this.rightGrid = '2';
        }
        console.warn(
            `Updated Grid Sizes - Left: ${this.leftGrid}, Middle: ${this.middleGrid}, Right: ${this.rightGrid}`,
        );
    }

    private setTitleWidthDynamically() {
        if (!this.headerRow || !this.titleContainer || !this.rightCol) return;
        const parentWidth = this.headerRow.nativeElement.clientWidth;
        const rightColWidth = this.rightCol.nativeElement.offsetWidth;
        if (!rightColWidth) return;
        const padding = 16;
        const titleWidth = (parentWidth / 2 - (rightColWidth + padding)) * 2;
        this.titleContainer.nativeElement.style.width = `${titleWidth}px`;
    }

    private setTitleHeightDynamically() {
        if (!this.headerRow || !this.titleContainer || !this.titleRef) return;
        if (!this.headerRowHeight) {
            this.headerRowHeight = this.headerRowHeight = this.headerRow.nativeElement.clientHeight;
        }
        const parentHeight = this.headerRow.nativeElement.clientHeight;
        const titleHeight = this.titleRef.nativeElement.offsetHeight;
        let newHeightFactor =
            titleHeight > parentHeight
                ? Math.floor(titleHeight / parentHeight)
                : (Math.floor(parentHeight / titleHeight) - 1) * -1;
        let newHeight = parentHeight + this.headerRowHeight * newHeightFactor;
        this.headerRow.nativeElement.style.height = `${newHeight}px`;
        this.titleContainer.nativeElement.style.height = `${newHeight}px`;
    }
}
